import { Link } from "react-router-dom";
import { SITE } from "@/config/site";

export const Footer = () => (
  <footer className="border-t border-white/[0.06] bg-[#0b0e13] py-16" data-testid="site-footer">
    <div className="mx-auto flex max-w-7xl flex-col gap-10 px-5 sm:px-8 md:flex-row md:items-end md:justify-between">
      <div>
        <p className="font-serif text-2xl text-cream">
          Proměna <span className="text-copper">muže</span>
        </p>
        <p className="mt-3 text-sm text-cream/50">
          <a
            href={SITE.siteUrl}
            className="transition-colors hover:text-copper"
            data-testid="footer-site-link"
          >
            promenamuze.cz
          </a>
        </p>
        <a
          href={`mailto:${SITE.contactEmail}`}
          className="mt-1 block text-sm text-cream/50 transition-colors hover:text-copper"
          data-testid="footer-email-link"
        >
          {SITE.contactEmail}
        </a>
      </div>

      <nav aria-label="Právní odkazy" className="flex flex-col gap-3 text-sm sm:flex-row sm:gap-8">
        <Link
          to="/kontakt"
          data-testid="footer-contact-link"
          className="text-cream/60 transition-colors hover:text-copper"
        >
          Kontakt
        </Link>
        <Link
          to="/obchodni-podminky"
          data-testid="footer-terms-link"
          className="text-cream/60 transition-colors hover:text-copper"
        >
          Obchodní podmínky
        </Link>
        <Link
          to="/ochrana-osobnich-udaju"
          data-testid="footer-privacy-link"
          className="text-cream/60 transition-colors hover:text-copper"
        >
          Ochrana osobních údajů
        </Link>
      </nav>
    </div>
    <div className="mx-auto mt-12 max-w-7xl px-5 sm:px-8">
      <p className="text-xs text-cream/30">
        © {new Date().getFullYear()} {SITE.brand}. Všechna práva vyhrazena.
      </p>
    </div>
  </footer>
);
